import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AdminLayout } from './components/layout/AdminLayout';
import { LoginPage } from './features/auth/LoginPage';

// Placeholder Pages (will be implemented next)
import { DashboardPage } from './features/dashboard/DashboardPage';
import { BlogListPage } from './features/blog/BlogListPage';
import { BlogEditorPage } from './features/blog/BlogEditorPage';
import { CommunityPage } from './features/community/CommunityPage';
import { QuizBuilderPage } from './features/quiz/QuizBuilderPage';
import { MazeManagerPage } from './features/maze/MazeManagerPage';
import { UsersPage } from './features/users/UsersPage';
import { SettingsPage } from './features/settings/SettingsPage';
import { PagesEditorPage } from './features/pages/PagesEditorPage';
import CategoryPage from './pages/CategoryPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="blog">
            <Route index element={<BlogListPage />} />
            <Route path="new" element={<BlogEditorPage />} />
            <Route path="edit/:id" element={<BlogEditorPage />} />
          </Route>
          <Route path="categories" element={<CategoryPage />} />
          <Route path="pages" element={<PagesEditorPage />} />
          <Route path="community" element={<CommunityPage />} />
          <Route path="quiz" element={<QuizBuilderPage />} />
          <Route path="maze" element={<MazeManagerPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <Toaster theme="dark" position="top-right" />
    </BrowserRouter>
  );
}

export default App;
